module.exports = __webpack_public_path__ + "static/media/blank_2_2.1e70d621.png";